import { Formik } from "formik";
import React, { Component } from "react";
import { Button, Modal, Input, ModalBody, ModalHeader } from "reactstrap";
import AllStates from "../../components/AllStates";
import axiosInstance from "../../axios-project";
import OrganizationTable from "../../components/OrganizationTable/OrganizationTable";
import ContactTable from "../../components/ContactTable/ContactTable";
import ContactInputModal from "../../components/ContactModal/ContactInputModal";

class OrganizationOverview extends Component {
  state = {
    organizations: [],
    contacts: [],
    showContactModal: false,
    currentContactID: null,
    showOrganizationModal: false,
    showContactInputModal: false,
    currentOrganizationID: null,
    currentOrganization: null,
    currentContact: null,
    page: null,
  };

  changePage = p => {
    this.setState({
      page: p
    });
  };

  fetchOrganizations = () => {
    axiosInstance
      .get("/organization")
      .then(response => {
        this.setState(prevState => {
          return { organizations: response.data };
        });
      })
      .catch(error => {
        console.log(error);
      });
    return;
  };
  fetchContacts = organizationID => {
    axiosInstance
      .get("/contact/organization_id/" + organizationID)
      .then(response => {
        this.setState(prevState => {
          return { contacts: response.data };
        });
      })
      .catch(error => {
        console.log(error);
      });
    return;
  };

  fetchCountries = () => {
    axiosInstance
        .get("/country_lkp/")
        .then(response => {
          this.setState(prevState => {
            return { country_list: response.data };
          });
        })
        .catch(error => {
          console.log(error);
        });
    return;
  }

  componentWillMount = () => {
    this.fetchOrganizations();
    //this.fetchContacts();
    this.fetchCountries();
  };
  contactClicked = organizationID => {
    this.fetchContacts(organizationID);
    this.setState(prevState => {
      return {
        currentOrganizationID: organizationID,
        currentOrganization: this.state.organizations.find(
          a => a.organization_id === organizationID
        ),
        showContactModal: true
      };
    });
  };

  modifyContactClicked = contactID => {
    console.log(contactID);
    this.setState(prevState => {
      return {
        showOrganizationModal: true,
        currentContactID: contactID,
        currentContact: this.state.contacts.find(
          a => a.contact_id === contactID
        )
      };
    });
    this.toggleOrganizationModal();
    this.toggleContactInputModal();
  };

  organizationClicked = organizationID => {
    this.fetchCountries();
    this.setState(prevState => {
      return {
        showOrganizationModal: true,
        currentOrganizationID: organizationID,
        currentOrganization: this.state.organizations.find(
          a => a.organization_id === organizationID
        )
      };
    });
  };

  toggleContactModal = () => {
    this.setState(prevState => ({
      showContactModal: !prevState.showContactModal
    }));
  };
  toggleContactInputModal = () => {
    this.setState(prevState => ({
      showContactInputModal: !prevState.showContactInputModal
    }));
  };
  toggleOrganizationModal = () => {
    this.setState(prevState => ({
      showOrganizationModal: !prevState.showOrganizationModal
    }));
  };
  render() {
    // console.log(this.state.currentOrganizationID);

    const isAdmin =
        localStorage.getItem("role") &&
        JSON.parse(localStorage.getItem("role")).some(
            r => r.name === "ROLE_ADMIN"
        );

    return (
      <div>
        { isAdmin ? ( <div className="text-right">
          <button
            className={"btn btn-outline-primary btn-sm my-2"}
            type="button"
            onClick={() => this.organizationClicked(null)}
          >
            Create New organization
          </button>
        </div> ) : null }
        <OrganizationTable
          organizations={this.state.organizations}
          contacts={this.state.contacts}
          clicked={this.organizationClicked}
          contactClicked={this.contactClicked}
          page={this.state.page}
          changePage={this.changePage}
          countries={this.state.country_list}
        />
        <div>
          <Modal
            isOpen={this.state.showContactModal}
            fade
            size="lg"
            toggle={this.toggleContactModal}
            backdrop="static"
          >
            <ModalHeader toggle={this.toggleContactModal}>Contacts</ModalHeader>
            <ModalBody>
              { isAdmin ? ( <div className=" text-right">
                <Button
                  color="primary"
                  size="sm"
                  className="mb-2"
                  onClick={this.modifyContactClicked}
                >
                  Create New Contact
                </Button>
              </div> ) : null }
              <ContactTable
                contacts={this.state.contacts}
                modifyContactClicked={this.modifyContactClicked}
                fetchContacts={this.fetchContacts}
              />
            </ModalBody>
          </Modal>
        </div>
        <div>
          <Modal
            isOpen={this.state.showOrganizationModal}
            toggle={this.toggleOrganizationModal}
            backdrop="static"
          >
            <ModalHeader toggle={this.toggleOrganizationModal}>
              {(this.state.currentOrganizationID ? "Update" : "Create") +
                " Organization"}
            </ModalHeader>
            <ModalBody>
              <div>
                <small className={"d-block"}>
                  <span style={{ color: "red" }}>*</span> required
                </small>
                <Formik
                  initialValues={this.state.currentOrganization}
                  onSubmit={(values, { setSubmitting }) => {
                    this.toggleOrganizationModal();
                    console.log(values);
                    axiosInstance
                      .post("/organization", values)
                      .then(response => {
                        this.fetchOrganizations();
                        console.log(response);
                      })
                      .catch(e => {
                        console.log(e);
                      });
                  }}
                >
                  {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting
                    /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="form-row">
                        <label className="col-sm-3 required">Name</label>
                        <input
                          required
                          type="text"
                          name="name"
                          maxLength="100"
                          className="form-control col-sm-8"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.name || ""}
                          disabled={!isAdmin}
                        />
                      </div>
                      <div className="form-row">
                        <label className="col-sm-3 required">Parent Organization </label>
                        <Input
                            className="form-control col-sm-8"
                            type="select"
                            id="parent_organization_id"
                            name="parent_organization_id"
                            onChange={handleChange}
                            value={values.parent_organization_id ? values.parent_organization_id : -1}
                            disabled={!isAdmin}
                        >
                          <option value={-1} key={-1} disabled>
                            Select a Parent Organization
                          </option>
                          {this.state.organizations.map(org => (
                              <option value={org.organization_id} key={org.organization_id}>
                                {org.name}
                              </option>
                          ))}
                        </Input>
                      </div>






                      <div className="form-row">
                        <label className="col-sm-3">Street Address</label>
                        <input
                          type="text"
                          name="street_address"
                          maxLength="30"
                          className="form-control col-sm-8"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.street_address || ""}
                          disabled={!isAdmin}
                        />
                      </div>
                      <div className="form-row">
                        <label className="col-sm-3">City </label>
                        <input
                            type="text"
                            name="city"
                            maxLength="30"
                            className="form-control col-sm-8"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.city || ""}
                            disabled={!isAdmin}
                        />
                      </div>
                      <div className="form-row">
                        <label className="col-sm-3"> County </label>

                        <input
                            type="text"
                            name="county"
                            maxLength="40"
                            className="form-control col-sm-8"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.county || ""}
                            disabled={!isAdmin}
                        />
                      </div>
                      <div className="form-row">
                        <label className="col-sm-3 required">Country </label>
                        <Input
                            className="form-control col-sm-8"
                            type="select"
                            id="country_id"
                            name="country_id"
                            onChange={handleChange}
                            value={values.country_id ? values.country_id : 0}
                            disabled={!isAdmin}
                        >
                            <option value={0} key={0} disabled>
                                Select a Country
                            </option>
                          {this.state.country_list.map(country => (
                              <option value={country.country_id} key={country.country_id}>
                                {country.country_name}
                              </option>
                          ))}
                        </Input>
                      </div>
                      { (parseInt(values.country_id) === 1) ? (
                          <div className="form-row">
                            <label className="col-sm-3 required">State </label>
                            <Input
                                required
                                className="form-control col-sm-8"
                                type="select"
                                id="state_id"
                                name="state_id"
                                onChange={handleChange}
                                value={values.state_id ? values.state_id : 58}
                                disabled={!isAdmin}
                            >
                              {AllStates.map(state => (
                                  <option value={state.state_id} key={state.state_id}>
                                    {state.state_name}
                                  </option>
                              ))}
                            </Input>
                          </div>) : ""}
                      <div className="form-row">
                        <label className="col-sm-3"> Zipcode </label>

                        <input
                          type="number"
                          name="zipcode"
                          maxLength="20"
                          className="form-control col-sm-8"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.zipcode || ""}
                          disabled={!isAdmin}
                        />
                      </div>
                      <div className="form-row">
                        <label className="col-sm-3">Website</label>
                        <input
                          type="text"
                          name="website"
                          maxLength="100"
                          className="form-control col-sm-8"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.website || ""}
                          disabled={!isAdmin}
                        />
                      </div>
                      <div className="form-row">
                        <label className="col-sm-3">Service </label>
                        <input
                          name="service"
                          className="form-control col-sm-8"
                          maxLength="30"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.service | ""}
                          disabled={!isAdmin}
                        />
                      </div>
                      <div className="form-row">
                        <label className="col-sm-3">Description </label>
                        <textarea
                          name="discription"
                          maxLength="4000"
                          className="form-control col-sm-8"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.discription || ""}
                          disabled={!isAdmin}
                        />
                      </div>
                      <div className="form-row">
                        <label className="col-sm-3">Notes </label>
                        <textarea
                          name="notes"
                          maxLength="4000"
                          className="form-control col-sm-8"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.notes || ""}
                          disabled={!isAdmin}
                        />
                      </div>
                      <br />
                      {isAdmin ? (
                      <Button color="primary" type="submit">
                        Submit
                      </Button> ) : null } {" "}
                      {isAdmin ? (
                          <Button
                        color="secondary"
                        onClick={this.toggleOrganizationModal}
                      >
                        Cancel
                      </Button>
                        ) : null }
                    </form>
                  )}
                </Formik>
              </div>
            </ModalBody>
          </Modal>
        </div>
        <ContactInputModal
          showContactInputModal={this.state.showContactInputModal}
          toggleContactInputModal={this.toggleContactInputModal}
          currentContact={this.state.currentContact}
          currentOrganization={this.state.currentOrganization}
          fetchContacts={this.fetchContacts}
        />
      </div>
    );
  }
}

export default OrganizationOverview;
